<style lang="less">
@import "./index.less";
</style>

<template>
  <div class="login-container">
    <div class="login-form-wrap">
      <div class="login-header" :style="logoUrl ? `background-image: url('${logoUrl}')` : ''">
        <span v-if="!logoUrl" class="login-header-title">{{ siteTitle }}</span>
      </div>
      <div class="login-form-background" :style="`background-image: url('${backgroundUrl}')`">
        <div class="login-form-half">
          <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="off"
                   label-position="left">
            <div class="login-form-box">
              <div class="title-container">
                <h3 class="title">企业员工{{loginMethodName}}登录</h3>
              </div>
              <div v-if="loginMethod === 'email'">
                <el-form-item prop="email">
                <span class="icon-container">
                  <svg-icon icon-class="login-user" />
                </span>
                  <el-input v-model="loginForm.email" placeholder="请输入邮箱" name="email" type="text" auto-complete="off"/>
                </el-form-item>
                <el-form-item prop="dynamicCode">
                <span class="icon-container">
                  <svg-icon icon-class="lock" />
                </span>
                  <el-input style="width: 154px; padding-right: 5px;" type="text" v-model="loginForm.dynamicCode" placeholder="请输入验证码" name="dynamicCode"
                            auto-complete="off" @keyup.enter.native="login"/>
                  <el-button style="width: 133px;" :disabled="!dynamicCode.canClick" type="primary" class="square-btn" @click.native.prevent="sendCode">
                    {{dynamicCode.buttonText}}
                  </el-button>
                </el-form-item>

                <el-button :loading="loading" type="primary" class="green-btn" style="width:100%;margin-bottom:30px;font-size: 18px"
                           @click.native.prevent="login">
                  登 录
                </el-button>
              </div>
              <div style="text-align: center" v-if="loginMethod === 'dingtalk'">
                <el-select placeholder="请选择公司" v-model="companyId" v-if="activity.companies.length > 1">
                  <el-option
                    v-for="company in activity.companies"
                    :key="company.id"
                    :label="company.name"
                    :value="company.id">
                  </el-option>
                </el-select>
                <div id="ddlogin-container" class="ddlogin-container">
                  二维码
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <LoginFooter />
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import qs from 'qs'
const { mapState: activityMapState } = createNamespacedHelpers('activity')
import LoginFooter from './footer'
import config from '@/config'

const dynamicCodeRule = [{ message:'请输入验证码', trigger: 'blur', required: true }]
const countTime = 60

export default {
  name: 'Login',
  components: {
    LoginFooter
  },
  data() {
    return {
      loginForm: {
        email: '',
        dynamicCode: ''
      },
      loginRules: {
        email: this.$formHelper.rules.emailRequired,
        dynamicCode: dynamicCodeRule
      },
      dynamicCode: {
        'buttonText': '发送验证码',
        'totalTime': countTime,
        'canClick': true,
      },
      loading: false,
      redirectToName: undefined,
      companyId: undefined,
      logoUrl: config.siteLogo,
      siteTitle: config.siteTitle,
      backgroundUrl: config.loginBackground,
    }
  },
  computed: {
    ...activityMapState([
      'activity'
    ]),
    loginMethod() {
      if (this.activity) {
        return this.activity.loginMethod
      } else {
        return 'email'
      }
    },
    loginMethodName() {
      const names = {
        dingtalk: '钉钉',
        email: '邮箱',
      }
      return names[this.loginMethod]
    }
  },
  mounted() {

    if (!this.activity) {
      this.$alert('登录链接已过期，请从活动地址从新进入系统')
      this.$router.replace({ name: '404' })
    } else {
      const company = this.activity.companies[0]
      if (company) {
        this.companyId = company.id
      }
      this.company = this.activity.companies[0]
      this.$store.dispatch('activity/setId', this.activity.id)
    }
  },
  watch: {
    companyId() {
      if (this.loginMethod === 'dingtalk') {
        this.initDingTalkLogin()
      }
    },
    $route: {
      handler: function (route) {
        this.redirectToName = route.query && route.query.redirectToName
      },
      immediate: true
    }
  },
  methods: {
    initDingTalkLogin() {
      const dingTalkConfig = this.getDigntalkConfig()
      if (!dingTalkConfig) {
        this.$message.error('钉钉登录配置不存在')
        return
      }
      const currentCompany = this.getCurrentCompany()
      const redirectUri = `${this.$config.client.web.baseUrl}/ddcallback/${currentCompany.id}`
      window.DTFrameLogin({
        id: 'ddlogin-container',
        width: 300,
        height: 280,
      }, {
        redirect_uri: encodeURIComponent(redirectUri),
        client_id: dingTalkConfig.oauthAppId,
        scope: 'openid',
        response_type: 'code',
        state: 'STATE',
        prompt: 'consent',
      }, (loginResult) => {
        const {redirectUrl, authCode, state} = loginResult;
        // 这里可以直接进行重定向
        window.location.href = redirectUrl;
        // 也可以在不跳转页面的情况下，使用code进行授权
        console.log(authCode, 'authCode');
      }, (errorMsg) => {
        // 这里一般需要展示登录失败的具体原因
        this.$message.error(`登录错误: ${errorMsg}`)
      })
    },
    getCurrentCompany() {
      const companies = this.activity.companies
      return companies.find(company => company.id == this.companyId)
    },
    getDigntalkConfig() {
      const company = this.getCurrentCompany()
      return company? company.dingtalkConfig : undefined
    },
    async login() {
      this.loginRules.dynamicCode = dynamicCodeRule
      await this.$formHelper.promisedValidate(this.$refs.loginForm)
      try {
        this.loading = true
        await this.$store.dispatch('auth/login', this.loginForm)
        this.$router.push({ name: this.redirectToName || 'home' })
      } finally {
        this.loading = false
      }
    },
    async sendCode() {
      const loginForm = this.$refs.loginForm
      loginForm.clearValidate()
      this.loginRules.dynamicCode = null
      await this.$formHelper.promisedValidate(loginForm)
      const { email } = this.loginForm
      if (!email) {
        this.$message.error('请输入您的企业邮箱')
        return
      }

      try {

        this.dynamicCode.canClick = false

        await this.$store.dispatch('code/send', {
          email
        })
      } finally {
        this.dynamicCode.canClick = true
      }
      this.countDown()
      this.$alert(`验证码已发送到您的${email}邮箱请查收，可能会有2～3分钟的收件延迟请稍等；如未收到，可在第一次获取60s后重试；`)
    },
    countDown () {
      if (!this.dynamicCode.canClick) return
      this.dynamicCode.canClick = false
      this.dynamicCode.buttonText = this.dynamicCode.totalTime + 's后重新发送'
      let clock = window.setInterval(() => {
        this.dynamicCode.totalTime--
        this.dynamicCode.buttonText = this.dynamicCode.totalTime + 's后重新发送'
        if (this.dynamicCode.totalTime < 0) {
          window.clearInterval(clock)
          this.dynamicCode.buttonText = '重新发送验证码'
          this.dynamicCode.totalTime = countTime
          this.dynamicCode.canClick = true   //这里重新开启
        }
      },1000)
    }
  }
}
</script>
<style scoped>
/* STEP2：指定这个包裹容器元素的CSS样式，尤其注意宽高的设置 */
.ddlogin-container {
  margin-left: auto;
  margin-right: auto;
  width: 300px;
  height: 300px;
}
</style>
